<template>
  <span>
    <Dialog
      class="test-box"
      :header="headerDialog"
      :visible.sync="showRemoverDestinatario"
      :modal="true"
      :closable="false"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>
              {{
                "O destinatário" +
                  " " +
                  (this.pessoa ? this.pessoa.detail : "") +
                  " será removido."
              }}
            </p>
            <p>
              {{ "Deseja continuar?" }}
            </p>
          </div>
        </div>
      </div>

      <hr />

      <div class="botoes-avancar-voltar">
            <Button
              @click="removerDestinatario()"
              href="#topo"
              type="button"
              label="Remover"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-check"
              :disabled="loading"
            />

            <Button
              @click="showRemoverDestinatario = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
      </div>
    </Dialog>
  </span>
</template>

<script>
import NfsPessoaService from "@/services/nfse/pessoa.service";

export default {
  name: "RemoverDestinatario",

  props: {
    tipoEmissao: String
  },

  created() {
    this.$root.$on("notaFiscal:removerDestinatario", () => {
      this.pessoa = this.$parent.selectedPessoaDestinatario;

      this.exibirDialogRemoverDestinatario();
    });
  },

  data() {
    return {
      showRemoverDestinatario: false,
      pessoa: null
    };
  },

  methods: {
    exibirDialogRemoverDestinatario() {
      this.showRemoverDestinatario = true;
    },

    removerDestinatario() {
      if (this.pessoa && this.pessoa.id) {
        this.$parent.processando(true);
        this.$parent.erros = [];

        NfsPessoaService.remove(this.pessoa.id)
          .then(
            data => {
              console.log(data);
              this.$root.$emit(
                "alert:success",
                "O Destinatario foi removido!"
              );
            },
            error => {
              console.log(error);
              this.$root.$emit(
                "alert:success",
                "Houve um problema ao remover o Destinatário!"
              );
            }
          )
          .then(() => {
            if (this.$parent.$options.name == "EmissaoNfse") {
              this.$parent.notaFiscal.idDestinatarioDados = null;
            } 

            this.$parent.selectedPessoaDestinatario = null;
            this.showRemoverDestinatario = false;
            this.$parent.processando(false);
          });
      }
    }
  },

  computed: {
    headerDialog() {
      return "Remover Destinatário";
    },

    loading() {
      return this.$parent.loading;
    }
  }
};
</script>

<style scoped></style>
